import InformeCep from '../informeCep'
import { Container } from './styles'

type Props = {
  isActive: boolean
  setIsActive: (value: boolean) => void
}

const InformaCepMobile = ({ isActive, setIsActive }: Props) => (
  <Container>
    <InformeCep isActive={isActive} setIsActive={setIsActive} />
  </Container>
)

export default InformaCepMobile
